<div class="admin-shell">
  <aside class="admin-sidebar" [attr.aria-label]="'HOSPITAL_ADMIN.NAVIGATION_LABEL' | translate">
    <div class="brand-block">
      <img src="assets/images/logos/klinaro_transparent.png" alt="Klinaro" class="hospital-logo" />
    </div>

    <nav class="sidebar-nav">
      <a class="nav-item active" aria-current="page">
        <i-tabler name="building-hospital" class="icon-22"></i-tabler>
        <span>{{ 'HOSPITAL_ADMIN.HOSPITALS' | translate }}</span>
      </a>
    </nav>

    <button class="sidebar-logout" type="button" (click)="logout()">
      <i-tabler name="logout" class="icon-20"></i-tabler>
      <span>{{ 'HOSPITAL_ADMIN.LOGOUT' | translate }}</span>
    </button>
  </aside>

  <div class="admin-workspace">
    <main class="page-content">
      <section class="page-heading">
        <div>
          <h1>{{ 'HOSPITAL_ADMIN.HOSPITALS' | translate }}</h1>
          <p>{{ 'HOSPITAL_ADMIN.PAGE_DESCRIPTION' | translate }}</p>
        </div>
        <button mat-flat-button color="primary" class="add-hospital-button" type="button" (click)="addHospital()">
          <mat-icon>add</mat-icon>
          {{ 'HOSPITAL_ADMIN.ADD_HOSPITAL' | translate }}
        </button>
      </section>

      <section class="stat-grid" [attr.aria-label]="'HOSPITAL_ADMIN.SUMMARY_LABEL' | translate">
        <article class="stat-card stat-blue">
          <span class="stat-icon"><i-tabler name="building-hospital" class="icon-26"></i-tabler></span>
          <span><strong>{{ totalHospitals }}</strong><small>{{ 'HOSPITAL_ADMIN.TOTAL_HOSPITALS' | translate }}</small></span>
        </article>
        <article class="stat-card stat-green">
          <span class="stat-icon"><i-tabler name="circle-check" class="icon-26"></i-tabler></span>
          <span><strong>{{ summary ? summary.active : '—' }}</strong><small>{{ 'HOSPITAL_ADMIN.ACTIVE_HOSPITALS' | translate }}</small></span>
        </article>
        <article class="stat-card stat-red">
          <span class="stat-icon"><i-tabler name="circle-x" class="icon-26"></i-tabler></span>
          <span><strong>{{ summary ? summary.inactive : '—' }}</strong><small>{{ 'HOSPITAL_ADMIN.INACTIVE_HOSPITALS' | translate }}</small></span>
        </article>
        <article class="stat-card stat-purple">
          <span class="stat-icon"><i-tabler name="heart-handshake" class="icon-26"></i-tabler></span>
          <span><strong>{{ summary ? summary.abdmEnabled : '—' }}</strong><small>{{ 'HOSPITAL_ADMIN.ABDM_ENABLED_HOSPITALS' | translate }}</small></span>
        </article>
        <article class="stat-card stat-amber">
          <span class="stat-icon"><i-tabler name="building-store" class="icon-26"></i-tabler></span>
          <span><strong>{{ summary ? summary.pharmacyEnabled : '—' }}</strong><small>{{ 'HOSPITAL_ADMIN.PHARMACY_ENABLED_HOSPITALS' | translate }}</small></span>
        </article>
      </section>

      <section class="filter-panel" [attr.aria-label]="'HOSPITAL_ADMIN.FILTERS_LABEL' | translate">
        <mat-form-field appearance="outline" class="search-control hide-hint">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [placeholder]="'HOSPITAL_ADMIN.SEARCH_PLACEHOLDER' | translate"
            [formControl]="searchControl" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="hide-hint">
          <mat-label>{{ 'HOSPITAL_ADMIN.STATUS' | translate }}</mat-label>
          <mat-select [formControl]="statusControl">
            <mat-select-trigger>
              {{ (statusControl.value === 'active' ? 'HOSPITAL_ADMIN.ACTIVE' : statusControl.value === 'inactive' ? 'HOSPITAL_ADMIN.INACTIVE' : 'HOSPITAL_ADMIN.ALL') | translate }}
            </mat-select-trigger>
            <mat-option value="all">{{ 'HOSPITAL_ADMIN.ALL' | translate }}</mat-option>
            <mat-option value="active">{{ 'HOSPITAL_ADMIN.ACTIVE' | translate }}</mat-option>
            <mat-option value="inactive">{{ 'HOSPITAL_ADMIN.INACTIVE' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="hide-hint">
          <mat-label>{{ 'HOSPITAL_ADMIN.CITY' | translate }}</mat-label>
          <mat-select [formControl]="cityControl">
            <mat-option value="all">{{ 'HOSPITAL_ADMIN.ALL' | translate }}</mat-option>
            <mat-option *ngFor="let city of cityOptions" [value]="city">{{ city }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="hide-hint">
          <mat-label>{{ 'HOSPITAL_ADMIN.ABDM' | translate }}</mat-label>
          <mat-select [formControl]="abdmControl">
            <mat-select-trigger>
              {{ (abdmControl.value === 'true' ? 'HOSPITAL_ADMIN.ENABLED' : abdmControl.value === 'false' ? 'HOSPITAL_ADMIN.DISABLED' : 'HOSPITAL_ADMIN.ALL') | translate }}
            </mat-select-trigger>
            <mat-option value="all">{{ 'HOSPITAL_ADMIN.ALL' | translate }}</mat-option>
            <mat-option value="true">{{ 'HOSPITAL_ADMIN.ENABLED' | translate }}</mat-option>
            <mat-option value="false">{{ 'HOSPITAL_ADMIN.DISABLED' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="hide-hint">
          <mat-label>{{ 'HOSPITAL_ADMIN.PHARMACY' | translate }}</mat-label>
          <mat-select [formControl]="pharmacyControl">
            <mat-select-trigger>
              {{ (pharmacyControl.value === 'true' ? 'HOSPITAL_ADMIN.ENABLED' : pharmacyControl.value === 'false' ? 'HOSPITAL_ADMIN.DISABLED' : 'HOSPITAL_ADMIN.ALL') | translate }}
            </mat-select-trigger>
            <mat-option value="all">{{ 'HOSPITAL_ADMIN.ALL' | translate }}</mat-option>
            <mat-option value="true">{{ 'HOSPITAL_ADMIN.ENABLED' | translate }}</mat-option>
            <mat-option value="false">{{ 'HOSPITAL_ADMIN.DISABLED' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-stroked-button type="button" class="reset-button" (click)="resetFilters()">
          <i-tabler name="refresh" class="icon-18"></i-tabler>
          {{ 'HOSPITAL_ADMIN.RESET' | translate }}
        </button>
      </section>

      <section class="table-card">
        <div class="table-loading" *ngIf="isLoading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" class="hospital-table" *ngIf="dataSource.filteredData.length > 0">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.HOSPITAL' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <div class="hospital-cell">
                  <span class="hospital-mark"><i-tabler name="building-hospital" class="icon-20"></i-tabler></span>
                  <strong>{{ hospital.name }}</strong>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="registrationNumber">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.REGISTRATION_NO' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">{{ hospital.registrationNumber || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.CITY' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="cell-with-icon"><i-tabler name="map-pin" class="icon-17"></i-tabler>{{ hospital.city || '—'
                  }}<ng-container *ngIf="hospital.state">, {{ hospital.state }}</ng-container></span>
              </td>
            </ng-container>

            <ng-container matColumnDef="mobile">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.CONTACT' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="cell-with-icon"><i-tabler name="phone" class="icon-17"></i-tabler>{{ hospital.mobile ||
                  hospital.phone || '—' }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.STATUS' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="status-pill" [class.disabled]="hospital.isActive === false"><span
                    class="pill-dot"></span>{{ (hospital.isActive === false ? 'HOSPITAL_ADMIN.INACTIVE' : 'HOSPITAL_ADMIN.ACTIVE') | translate }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="abdm">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.ABDM' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="status-pill" [class.disabled]="!hospital.isAbdmEnabled"><span class="pill-dot"></span>{{
                  (hospital.isAbdmEnabled ? 'HOSPITAL_ADMIN.ENABLED' : 'HOSPITAL_ADMIN.DISABLED') | translate }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ipd">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.IPD' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="status-pill" [class.disabled]="!hospital.isIPD"><span class="pill-dot"></span>{{
                  (hospital.isIPD ? 'HOSPITAL_ADMIN.ENABLED' : 'HOSPITAL_ADMIN.DISABLED') | translate }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="pharmacy">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.PHARMACY' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="status-pill" [class.disabled]="!hospital.isPharmacyEnabled"><span
                    class="pill-dot"></span>{{ (hospital.isPharmacyEnabled ? 'HOSPITAL_ADMIN.ENABLED' : 'HOSPITAL_ADMIN.DISABLED') | translate }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="whatsApp">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.WHATSAPP' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <span class="status-pill" [class.disabled]="!hospital.isWhatsAppEnabled"><span class="pill-dot"></span>{{
                  (hospital.isWhatsAppEnabled ? 'HOSPITAL_ADMIN.ENABLED' : 'HOSPITAL_ADMIN.DISABLED') | translate }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="documentActions">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.LEGACY_DOCUMENTS' | translate }}</th>
              <td mat-cell *matCellDef="let hospital">
                <button mat-stroked-button class="copy-button" type="button" [disabled]="isAnyDocumentOperationRunning"
                  (click)="confirmLegacyDocumentCopy(hospital)">
                  <mat-spinner *ngIf="isDocumentOperationRunning(hospital.id, 'copy')" diameter="16"></mat-spinner>
                  <i-tabler *ngIf="!isDocumentOperationRunning(hospital.id, 'copy')" name="copy"
                    class="icon-17"></i-tabler>
                  {{ 'HOSPITAL_ADMIN.COPY' | translate }}
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ 'HOSPITAL_ADMIN.ACTIONS' | translate }}</th>
              <td mat-cell *matCellDef="let hospital" class="action-link">
                <button type="button" class="hospital-edit-action cursor-pointer" (click)="editHospital(hospital)"
                  [attr.aria-label]="'HOSPITAL_ADMIN.EDIT' | translate"
                  [matTooltip]="'HOSPITAL_ADMIN.EDIT' | translate">
                  <i-tabler name="edit" class="icon-18"></i-tabler>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div class="empty-state" *ngIf="!isLoading && dataSource.filteredData.length === 0">
            <span class="empty-icon"><i-tabler name="building-hospital" class="icon-28"></i-tabler></span>
            <strong>{{ 'HOSPITAL_ADMIN.NO_HOSPITALS_FOUND' | translate }}</strong>
            <p>{{ 'HOSPITAL_ADMIN.CHANGE_FILTERS_HINT' | translate }}</p>
          </div>
        </div>

        <section class="document-result" *ngIf="documentOperationResult as result" aria-live="polite">
          <div class="result-heading">{{ result.title }} — {{ result.hospitalName }}</div>
          <div class="result-stats">
            <span>{{ 'HOSPITAL_ADMIN.FOUND' | translate }}: {{ result.found }}</span><span>{{ 'HOSPITAL_ADMIN.COPIED' | translate }}: {{ result.completed }}</span>
            <span>{{ 'HOSPITAL_ADMIN.MISSING' | translate }}: {{ result.missing }}</span><span>{{ 'HOSPITAL_ADMIN.FAILED' | translate }}: {{ result.failed }}</span>
          </div>
          <div class="result-errors" *ngIf="result.errors.length > 0">
            <strong>{{ 'HOSPITAL_ADMIN.FAILED_DOCUMENT_LOG' | translate }}</strong>
            <ul>
              <li *ngFor="let error of result.errors">{{ error }}</li>
            </ul>
          </div>
        </section>

        <mat-paginator *ngIf="pagination && dataSource.data.length > 0" [ngClass]="{'pointer-events-none': isLoading}"
          [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageIndex]="pagination.currentPage"
          [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="onPageChange($event)">
        </mat-paginator>
      </section>
    </main>
  </div>
</div>